import { useState } from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import Product from "@ltypes/product";
import { timezones } from "../../../constants";
import ProductService from "@services/ProductService";
import Card from "@components/ui/Card/Card";
import TextField from "@components/forms/TextField/TextField";
import Button from "@components/forms/Button/Button";
import Select from "@components/forms/Select/Select";
import "./ProductForm.scss";

type ProductFormProps = {
    product: Product,
    className?: string,
    onUpdate: (formData: {[key: string]: any}) => void,
};

function ProductForm(props: ProductFormProps) {
    const initialData: {[key: string]: any} = {
        name: props.product.name,
        timezone: props.product.timezone,
        night_mode_start: props.product.night_mode_start,
        night_mode_stop: props.product.night_mode_stop,
    };

    const [updating, setUpdating] = useState<boolean>(false);
    const [formData, setFormData] = useState<{[key: string]: any}>(initialData);

    const { t } = useTranslation();

    const service = new ProductService;

    const handleCancel = () => {
        setFormData(initialData);
        setUpdating(false);
    };

    const handleChange = (field: string, value: any) => {
        setFormData({
            ...formData,
            [field]: value,
        });

        setUpdating(true);
    };

    const handleSave = () => {
        setUpdating(false);
        service.update(props.product.id, formData).then(() => {
            toast.success(t('toast.updated'));
            props.onUpdate(formData);
        }).catch((e) => {
            toast.error(t('toast.error_lumeba_update'));
            setUpdating(true);
        });
    };

    return (
        <Card className={`product-form ${props.className}`}>
            <div className="row g-3">
                <div className="col-12">
                    <TextField label={t('page.dashboard.product_name')} value={formData.name} disabled={!props.product.is_connected} onChange={(value: string) => handleChange('name', value)}/>
                </div>
                <div className="col-12">
                    <Select label={t('page.dashboard.product_timezone')} value={formData.timezone} items={timezones} disabled={!props.product.is_connected} onChange={(value: string) => handleChange('timezone', Number(value))}/>
                </div>
                {/* <div className="col-12">
                    <Label>{t('page.dashboard.product_night_mode_hours')}</Label>
                    <div className="mt-1 d-flex align-items-center gap-3">
                        <TextField disabled label="" type="time" className="flex-0" value={formData.night_mode_start} onChange={(value: string) => handleChange('night_mode_start', value)}/>
                        <span className="flex-0">{t('date.to_hour')}</span>
                        <TextField disabled label="" type="time" className="flex-0" value={formData.night_mode_stop} onChange={(value: string) => handleChange('night_mode_stop', value)}/>
                    </div>
                </div> */}
            </div>

            <div className="btn-actions">
                <Button className="secondary" disabled={!updating || !props.product.is_connected} onClick={handleCancel}>{t('text.cancel')}</Button>
                <Button disabled={!updating || !props.product.is_connected} onClick={handleSave}>{t('text.save')}</Button>
            </div>
        </Card>
    );
}

export default ProductForm;
